import React, { Component } from 'react';
import {
	FaMobileAlt,
	FaEnvelope,
	FaShieldAlt,
	FaArrowLeft,
	FaCheck,
	FaLock
} from 'react-icons/fa';

export default class TwoFactor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errorBg: 0,
			selectedMethod: '',
			hoveredMethod: null,
			loginConfig: {
				sms: [
					{
						data: "number",
						type: "text",
						label: "Enter the Code sent to your mobile device.",
						error: ""
					}
				],
				email: [
					{
						data: "code",
						type: "text",
						label: "Enter the Code sent to your email.",
						error: ""
					}
				]
			},
			loginCreds: {},
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.login()
		}
	}

	fieldChange = (e) => {
		var newCreds = this.state.loginCreds
		newCreds[e.currentTarget.getAttribute('data-value')] = e.currentTarget.value
		this.setState({ loginCreds: newCreds })
	}

	login = (e) => {
		this.setState({ loading: true });
		window.setTimeout(function () {
			this.props.ws.send(JSON.stringify({
				route: 'twoFactor',
				loginCreds: this.state.loginCreds,
				method: this.state.selectedMethod,
				session: this.props.session
			}))
		}.bind(this), 200)
	}

	selectMethod = (method) => {
		this.setState({
			selectedMethod: method,
			loginCreds: {}
		});
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.setState({ loading: false, errorBg: 1 });
		}
		setTimeout(function () {
			this.setState({ errorBg: 0 });
		}.bind(this), 1000)
	}

	renderMethodSelection() {
		const methods = [
			{ id: 'sms', label: 'SMS', icon: FaMobileAlt },
			{ id: 'email', label: 'Email', icon: FaEnvelope }
		];

		return (
			<div style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '20px'
			}}>
				<div style={{
					display: 'flex',
					alignItems: 'center',
					gap: '10px',
					marginBottom: '5px'
				}}>
					<h3 style={{
						color: '#2A6AA9',
						fontWeight: '500',
						textAlign: 'center',
						fontSize: '16px',
						margin: 0
					}}>
						How would you like to receive your code?
					</h3>
				</div>

				{methods.map(method => {
					const Icon = method.icon;
					const isHovered = this.state?.hoveredMethod === method.id;

					return (
						<div
							key={method.id}
							onClick={() => this.selectMethod(method.id)}
							onMouseEnter={() => this.setState({ hoveredMethod: method.id })}
							onMouseLeave={() => this.setState({ hoveredMethod: null })}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '50px',
								width: '200px',
								borderRadius: '25px',
								backgroundColor: isHovered ? '#e0e0e0' : '#f2f2f2',
								cursor: 'pointer',
								transition: 'all 0.2s ease',
								userSelect: 'none',
								padding: '0 20px',
								boxShadow: isHovered ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
								transform: isHovered ? 'translateY(-1px)' : 'translateY(0)'
							}}
						>
							<div style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								width: '32px',
								height: '32px',
								borderRadius: '50%',
								backgroundColor: isHovered ? 'rgba(0,0,0,0.05)' : 'white',
								marginRight: '12px',
								transition: 'all 0.2s ease'
							}}>
								<Icon style={{
									fontSize: '16px',
									color: '#2A6AA9',
								}} />
							</div>
							<span style={{
								color: '#2A6AA9',
								fontWeight: '500',
								fontSize: '14px'
							}}>
								{method.label}
							</span>
						</div>
					);
				})}
			</div>
		);
	}

	render() {
		const { selectedMethod = '' } = this.state || {};
		var loginComps = [];

		if (selectedMethod) {
			for (var comp of this.state.loginConfig[selectedMethod]) {
				loginComps.push(
					<div className="snazzyInputBox" key={comp.data}>
						<div className="error">{comp.error}</div>
						<input
							className="textInput"
							type={comp.type}
							required
							value={this.state.loginCreds[comp.data] ? this.state.loginCreds[comp.data] : ''}
							data-value={comp.data}
							onChange={this.fieldChange}
						/>
						<span className="inputBar"></span>
						<label className="textLabel">{comp.label}</label>
					</div>
				)
			}
		}

		return (
			<div className="App">
				<div className="backdrop"></div>

				<div className="loginBox" onKeyUp={this.checkEnter}>

					{!selectedMethod ?
						this.renderMethodSelection()
						:
						<div>
							{loginComps}

							<div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
								{this.props.loginError ?
									<div
										className="error"
										style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}
									>
										{this.props.loginError}
									</div>
									: ''
								}

								{this.state.loading ?
									<div className="loader"></div>
									:
									<div style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										marginTop: '20px'
									}}>
										<div
											onClick={() => this.setState({ selectedMethod: '', loginCreds: {} })}
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												height: '40px',
												width: '100px',
												borderRadius: '20px',
												backgroundColor: '#f2f2f2',
												cursor: 'pointer',
												userSelect: 'none',
												transition: 'all 0.2s ease',
												boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
											}}
											onMouseEnter={e => {
												e.currentTarget.style.backgroundColor = '#e0e0e0';
												e.currentTarget.style.transform = 'translateY(-1px)';
												e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.15)';
											}}
											onMouseLeave={e => {
												e.currentTarget.style.backgroundColor = '#f2f2f2';
												e.currentTarget.style.transform = 'translateY(0)';
												e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
											}}
										>
											<FaArrowLeft style={{ fontSize: '14px', marginRight: '8px' }} />
											Back
										</div>
										<div
											onClick={this.login}
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												height: '40px',
												width: '130px',
												borderRadius: '20px',
												backgroundColor: '#2A6AA9',
												color: 'white',
												cursor: 'pointer',
												userSelect: 'none',
												transition: 'all 0.2s ease',
												boxShadow: '0 1px 3px rgba(42,106,169,0.3)',
											}}
											onMouseEnter={e => {
												e.currentTarget.style.backgroundColor = '#3177b9';
												e.currentTarget.style.transform = 'translateY(-1px)';
												e.currentTarget.style.boxShadow = '0 2px 5px rgba(42,106,169,0.4)';
											}}
											onMouseLeave={e => {
												e.currentTarget.style.backgroundColor = '#2A6AA9';
												e.currentTarget.style.transform = 'translateY(0)';
												e.currentTarget.style.boxShadow = '0 1px 3px rgba(42,106,169,0.3)';
											}}
										>
											Confirm Code
											<FaCheck style={{ fontSize: '14px', marginLeft: '8px' }} />
										</div>
									</div>
								}
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}